import * as React from 'react';

import { InjectedRouter } from 'react-router';
import { Mutation } from 'react-apollo';
import { loadGQLUserGroupByCode } from 'groups/lib/GroupPromises';
import { withRouter } from 'app/context/Router';
// @ts-ignore
import AuthActions from 'auth/AuthActions';

import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/Button';
import LoadingModal from 'components/LoadingModal';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import JoinGroupAvatarPanel from 'join/components/JoinGroupAvatarPanel';
import Link from 'components/Link';
import Row from 'components/Row';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import { touch } from 'actions/touchActions';
import { TOUCH_KEY as NAV_TOUCH_KEY } from 'components/NavigationList/NavigationList';
import JoinFlowGroupStorage from '../data/JoinFlowGroupStorage';

import JOIN_GROUP_BY_CODE_MUTATION from 'groups/components/mutations/JoinGroupByCode.gql';

import {
  joinGroupByCodeMutation,
  joinGroupByCodeMutationVariables,
} from 'groups/components/mutations/__generated__/joinGroupByCodeMutation';

type Props = {
  code: string;
  onRequestHide: () => {};
  onGroupNotFound?: () => {};
  router: InjectedRouter;
};

type State = {
  group: Group | null;
};

class JoinConfirmSubscriptionModal extends React.Component<Props, State> {
  state: State = {
    group: null,
  };

  static defaultProps = {
    onRequestHide: () => undefined,
  };

  async componentDidMount() {
    await this.loadGroup(this.props.code);
  }

  bypass = () => {
    this.props.router.push('/classes');
  };

  loadGroup = async (code: string) => {
    const groupToJoin = await GroupActions.searchGroupByCode(code);

    if (!groupToJoin) {
      ToastActions.showErrorToast('Group not found.');
      this.props.onRequestHide();
      if (this.props.onGroupNotFound) {
        this.props.onGroupNotFound();
      }
      this.bypass();
      return;
    }

    const userIsAlreadyConnected = await loadGQLUserGroupByCode(code);

    if (userIsAlreadyConnected) {
      ToastActions.showSuccessToast('You have already joined this class.');
      this.props.onRequestHide();
      this.props.router.push(`/classes/${code}`);
    } else if (groupToJoin.canJoin()) {
      this.setState({ group: groupToJoin });
    } else {
      ToastActions.showErrorToast('Can’t join this class');
      this.props.onRequestHide();
      this.bypass();
    }
  };

  signOutRequest = () => {
    AuthActions.signOut(`/join/${this.props.code}`, true);
  };

  render() {
    const { group } = this.state;
    const { code } = this.props;

    if (!group) {
      return <LoadingModal />;
    }
    return (
      <Mutation<joinGroupByCodeMutation, joinGroupByCodeMutationVariables>
        mutation={JOIN_GROUP_BY_CODE_MUTATION}
        onCompleted={() => {
          JoinFlowGroupStorage.setJoinedClassName(group.getName());
          ToastActions.showSuccessToast(`You’ve joined ${group.getName()}`);
          touch(NAV_TOUCH_KEY);
          this.props.onRequestHide();
          this.props.router.push(`/classes/${group.getCodeOrError()}`);
        }}
        onError={error => {
          ToastActions.showErrorToast(error.message);
          this.props.onRequestHide();
        }}>
        {joinGroupByCodeMutation => {
          return (
            <Dialog
              {...this.props}
              size="xsmall"
              className="JoinConfirmSubscriptionModal"
              eventScreenName="JoinConfirmSubscriptionModal">
              <BoxBody flush>
                <Row>
                  <JoinGroupAvatarPanel group={group} />
                </Row>
                <Button
                  full
                  onClick={() => {
                    joinGroupByCodeMutation({ variables: { input: { groupCode: code } } });
                  }}
                  className="JoinConfirmSubscriptionModal-button">
                  Join class
                </Button>
              </BoxBody>
              <BoxFooter hideBorder>
                {`Logged in as ${CurrentUser.getUser().getSignature()}`}
                <br />
                Not you? <Link onClick={this.signOutRequest}>Log out</Link>
              </BoxFooter>
            </Dialog>
          );
        }}
      </Mutation>
    );
  }
}

export { JoinConfirmSubscriptionModal };

export default withRouter(JoinConfirmSubscriptionModal);
